export default function IconRepo({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M15.75 15.5625H8.73045M2.25 13.875C2.25 14.3225 2.42779 14.7517 2.74426 15.0682C3.06073 15.3847 3.48994 15.5625 3.9375 15.5625H4.95703"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 0.5625C3.2745 0.5625 2.25 1.587 2.25 2.8125V13.875C2.25 12.9559 3.01838 12.1875 3.9375 12.1875H15.1875C15.4858 12.1875 15.75 11.9233 15.75 11.625V1.125C15.75 0.826635 15.4858 0.5625 15.1875 0.5625H4.5Z"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.625 15.5625V12.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 9C5.00092 9 4.875 8.87408 4.875 8.71875C4.875 8.56342 5.00092 8.4375 5.15625 8.4375"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 9C5.31158 9 5.4375 8.87408 5.4375 8.71875C5.4375 8.56342 5.31158 8.4375 5.15625 8.4375"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 6.375C5.00092 6.375 4.875 6.24908 4.875 6.09375C4.875 5.93842 5.00092 5.8125 5.15625 5.8125"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 6.375C5.31158 6.375 5.4375 6.24908 5.4375 6.09375C5.4375 5.93842 5.31158 5.8125 5.15625 5.8125"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 3.75C5.00092 3.75 4.875 3.62408 4.875 3.46875C4.875 3.31342 5.00092 3.1875 5.15625 3.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.15625 3.75C5.31158 3.75 5.4375 3.62408 5.4375 3.46875C5.4375 3.31342 5.31158 3.1875 5.15625 3.1875"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.96875 14.0625V17.4375L6.84375 16.0781L8.71875 17.4375V14.0625"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
